import { call, select } from 'redux-saga/effects';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { selectCrmEnabled, selectCallIngestion } from '../../../state/config/configSlice';
import { backendClient } from '../../../services/api/backend-client';
import bugsnagClient from '../../../services/bugsnag/bugsnag';

export function* logCallCRMSaga(action) {
    const { callId, callNumber, callType, callDuration } = action.payload;
    const { uid, domain, email, defaultCrm } = yield select(selectUserCredentials);
    const crmEnabled = yield select(selectCrmEnabled);
    const callIngestion = yield select(selectCallIngestion);

    if (!crmEnabled || !defaultCrm) {
        console.log(`CRM disabled or no default CRM set — skipping call ${callId} log.`);
        return;
    }

    // Webhook domains are logged from the PBX webhook
    if (callIngestion === 'webhook') {
        console.log(`Call ingestion is webhook - skipping call ${callId} log.`);
        return;
    }

    try {
        const params = {
            callId,
            callNumber,
            callType,
            domain,
            uid,
            email,
            duration: String(callDuration),
        };

        yield call(
            backendClient.post,
            `integrations/${defaultCrm}/log-call`,
            null,
            { params }
        );

        console.log(`✅ Call ${callId} logged to CRM.`);
    } catch (err) {
        bugsnagClient.notify(err);
        console.error(`Error logging call ${callId} to CRM:`, err);
    }
}